module.exports = {
      id: "chevron-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/icons.a7e6c507.svg#chevron-usage",
      toString: function () {
        return this.url;
      }
    }